import { openErrorDialogSimple, } from 'console/dialogs/error/redux/actions';
export const savePrivateSettings = (device_id, private_name, private_note) => async (dispatch, getState, { api }) => {
    try {
        await api.update_device(device_id, {
            individual_device_name: private_name,
            individual_device_note: private_note,
        });
    }
    catch (e) {
        dispatch(openErrorDialogSimple(e, 'Не получилось изменить настройки'));
    }
};
